import { Button, Form, Row, Space, theme } from "antd";
import FormItem from "../../form/form-item";
import { useCallback, useEffect } from "react";
import { useGetQualificationsQuery } from "../../../../api/plamo-api";
import PlamoApiWithSaveNotifications from "../../util/with-save-notification";

import { DeleteOutlined } from "@ant-design/icons";
import { AdvancedForm, useAdvancedFormContext } from "../../form/advanced-form";

const { useCreateQualificationWithSaveNotificationMutation, useUpdateQualificationWithSaveNotificationMutation, useDeleteQualificationWithSaveNotificationMutation } = PlamoApiWithSaveNotifications;


const AddQualificationButton = ({ onClick }) => {
  const advancedFormContext = useAdvancedFormContext()

  return (
    <Button onClick={onClick} disabled={advancedFormContext.readOnly}>
      Neue Qualifikation hinzufügen
    </Button>
  )
}

const DeleteButton = ({ onClick }) => {
  const advancedFormContext = useAdvancedFormContext()

  return (
    <Button icon={<DeleteOutlined />} onClick={onClick} disabled={advancedFormContext.readOnly} />
  )
}

function EmployeeQualifications({ employeeId }) {
  const [form] = Form.useForm();
  const { data } = useGetQualificationsQuery({ f: JSON.stringify({ "employee.id": { c: "EQ", v: employeeId }}), st: JSON.stringify({ id: 'asc' }) }) as any
  const [ createQualification, { isLoading: isCreatingSalary } ] = useCreateQualificationWithSaveNotificationMutation();
  const [ updateQualification, { isLoading: isUpdatingSalary } ] = useUpdateQualificationWithSaveNotificationMutation();
  const [ deleteQualification, { isLoading: isDeletingSalary } ] = useDeleteQualificationWithSaveNotificationMutation();
  //const relatives = useMemo(() => data.items || [], [data])

  const isLoading = isCreatingSalary || isUpdatingSalary || isDeletingSalary;

  const { token } = theme.useToken();

  const formStyle: React.CSSProperties = {
    maxWidth: 'none',
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  useEffect(() => {
      form.setFieldsValue(data)
  }, [form, data])

  const onFinish = useCallback(async (values: any) => {
    console.log('On finish', values);
    const promisesCreateUpdate = values.items.map(i => {
      if(i.id) {
        return updateQualification(i);
      } else {
        return createQualification(i);
      }
    })

    const promisesDelete = data.items.filter(i => !values.items.find(i2 => i.id === i2.id)).map(i => deleteQualification(i));
    
    await Promise.all([...promisesCreateUpdate, ...promisesDelete]);
  }, [createQualification, updateQualification, deleteQualification, data]);

  return (<AdvancedForm form={form} name="qualifications" style={formStyle} onFinish={onFinish} originalValues={data} isLoading={isLoading}>
    <Form.List name="items">
      {(fields, { add, remove }, { errors }) => <>{
        fields.map((field, index) => { return <>
          <Row><h3>Qualifikation { index + 1 } <DeleteButton  onClick={() => remove(index)} /></h3></Row>
          <Row gutter={24}>
            <FormItem field={field} fieldName="qualificationType" label="Funktion" type="backendEnum" typeData={{ showSearch: true, ident: "qualificationType" }} />
            <FormItem field={field} fieldName="startDate" label="Letzte Durchf." type="date" />
            <FormItem field={field} fieldName="dueDate" label="Nächste Fälligk." type="date" />
            <FormItem field={field} fieldName="reminder" label="Erinnerung" type="date" />
          </Row>
        </>})}
        <div style={{ textAlign: 'right', marginBottom: '24px', marginTop: '24px' }}>
          <Space size="small">
            <AddQualificationButton onClick={() => add({ employeeId })} />
          </Space>
        </div>
        </>
      }
    </Form.List> 
    </AdvancedForm>)
}

export default EmployeeQualifications